import { Add as AddIcon, Delete } from "@mui/icons-material";
import { Box, Button, TextField, Typography } from "@mui/material";
import { handleNodeState } from "common/constants/functions";
import _ from "lodash";

const Values = ({ nodeState, setNodeState }: any) => {
  const handleAddValue = () => {
    setNodeState((prev: any) => {
      const newState = _.cloneDeep(prev); // Deep clone the previous state to avoid mutation
      _.set(newState, "data.properties.properties.values", [
        ..._.get(newState, "data.properties.properties.values", []),
        { key: "", value: "" },
      ]);
      return newState;
    });
  };
  const handleDeleteValue = (index: number) => {
    setNodeState((prev: any) => {
      const newState = _.cloneDeep(prev); // Deep clone the previous state to avoid mutation
      const values = _.get(newState, "data.properties.properties.values", []);
      _.set(
        newState,
        "data.properties.properties.values",
        values.filter((_: any, i: any) => i !== index)
      );
      return newState;
    });
  };
  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 1 }}>
        Values
      </Typography>
      {nodeState?.data?.properties?.properties?.values?.map((val: any, i: number) => (
        <Box sx={{ display: "flex", gap: 1 }} key={i}>
          <TextField
            required
            margin="dense"
            name="key"
            label="Key"
            type="text"
            value={nodeState?.data?.properties?.properties?.values?.[i]?.key}
            fullWidth
            onChange={({ target: { name, value } }: any) =>
              handleNodeState(
                ["data", "properties", "properties", "values", i, name],
                value,
                setNodeState
              )
            }
          />
          <TextField
            required
            margin="dense"
            name="value"
            label="Value"
            type="text"
            value={nodeState?.data?.properties?.properties?.values?.[i]?.value}
            fullWidth
            onChange={({ target: { name, value } }: any) =>
              handleNodeState(
                ["data", "properties", "properties", "values", i, name],
                value,
                setNodeState
              )
            }
          />
          <Button
            color="error"
            size="small"
            sx={{ minWidth: "max-content" }}
            onClick={() => handleDeleteValue(i)}
          >
            <Delete />
          </Button>
        </Box>
      ))}
      <Button size="small" onClick={handleAddValue}>
        <AddIcon sx={{ mr: 0.5 }} />
        Value
      </Button>
    </>
  );
};

export default Values;
